import { useEffect, useRef, useState } from "react";
// REDUX
import { useLazyGetDebounceOverridesQuery } from "../../redux/debounceOverrides/debounceOverridesAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACES
import { DebounceOverrideInterface } from "../../interfaces/DebounceOverride.interface";

export default function useGetDebounceOverrides(bankIds: string[]) {
  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [debounceOverrides, setDebounceOverrides] = useState<
    DebounceOverrideInterface[]
  >([]);
  const [token, setToken] = useState<string | null>(null);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [triggerGetOverrides] = useLazyGetDebounceOverridesQuery();

  // Track previous bankIds to avoid redundant fetches
  const prevBankIdsRef = useRef<string>("");

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    GETJwtToken().then(setToken);
  }, []);

  useEffect(() => {
    if (!token || bankIds.length === 0) return;

    const fingerprint = bankIds.slice().sort().join(",");
    if (fingerprint === prevBankIdsRef.current) return;
    prevBankIdsRef.current = fingerprint;

    const fetchAll = async () => {
      const results: DebounceOverrideInterface[] = [];

      await Promise.all(
        bankIds.map(async (bankId) => {
          const resp = await triggerGetOverrides({ bankId, token }).unwrap();
          if (resp && resp.data) {
            results.push(...resp.data);
          }
        })
      );
      setDebounceOverrides(results);
    };

    fetchAll();
  }, [token, bankIds, triggerGetOverrides]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return { debounceOverrides };
}
